import { PageVisitEvent } from '@hotjar/webapp/features/Playbacks/types';

export enum EVENT_TYPE {
  ERROR,
  NAVIGATION,
}

export type ConsoleEvent = {
  type: EVENT_TYPE.ERROR | EVENT_TYPE.NAVIGATION;
  event: PageVisitEvent;
};
